import { Component, Input } from '@angular/core';
import { ColumnSettings } from '../../common/models';
import { SabisNgxCheckboxComponent } from 'sabis-components2';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'boolean-editor',
  templateUrl: './boolean-editor.component.html',
  styleUrls: ['./boolean-editor.component.scss'],
  imports: [
    SabisNgxCheckboxComponent,
    FormsModule
  ]
})
export class BooleanEditorComponent {
  @Input('record') record: any;
  @Input('column') column!: ColumnSettings;
}
